export const playSaleSound = () => {
  try {
    const AudioContext =
      window.AudioContext || (window as any).webkitAudioContext
    if (!AudioContext) return

    const ctx = new AudioContext()
    const now = ctx.currentTime

    // Classic "Cha-ching" sound

    // 1. Coin drop sound (descending metallic tone)
    const coinOsc = ctx.createOscillator()
    const coinGain = ctx.createGain()

    coinOsc.type = 'sine'
    coinOsc.frequency.setValueAtTime(800, now)
    coinOsc.frequency.exponentialRampToValueAtTime(400, now + 0.1)

    coinGain.gain.setValueAtTime(0.3, now)
    coinGain.gain.exponentialRampToValueAtTime(0.01, now + 0.15)

    coinOsc.connect(coinGain)
    coinGain.connect(ctx.destination)
    coinOsc.start(now)
    coinOsc.stop(now + 0.15)

    // 2. Register bell "ching" (bright high tone)
    const bellOsc = ctx.createOscillator()
    const bellGain = ctx.createGain()

    bellOsc.type = 'sine'
    bellOsc.frequency.setValueAtTime(2000, now + 0.08)

    bellGain.gain.setValueAtTime(0.4, now + 0.08)
    bellGain.gain.exponentialRampToValueAtTime(0.01, now + 0.4)

    bellOsc.connect(bellGain)
    bellGain.connect(ctx.destination)
    bellOsc.start(now + 0.08)
    bellOsc.stop(now + 0.4)

    // 3. Harmonic overtone for richness
    const harmOsc = ctx.createOscillator()
    const harmGain = ctx.createGain()

    harmOsc.type = 'sine'
    harmOsc.frequency.setValueAtTime(3000, now + 0.08)

    harmGain.gain.setValueAtTime(0.15, now + 0.08)
    harmGain.gain.exponentialRampToValueAtTime(0.01, now + 0.35)

    harmOsc.connect(harmGain)
    harmGain.connect(ctx.destination)
    harmOsc.start(now + 0.08)
    harmOsc.stop(now + 0.35)
  } catch (e) {
    console.error('Audio playback failed', e)
  }
}

export const playRankingChangeSound = () => {
  try {
    const AudioContext =
      window.AudioContext || (window as any).webkitAudioContext
    if (!AudioContext) return

    const ctx = new AudioContext()
    const now = ctx.currentTime

    // 1. Powerful whoosh effect (speed/movement)
    const noiseBuffer = ctx.createBuffer(
      1,
      ctx.sampleRate * 0.6,
      ctx.sampleRate,
    )
    const output = noiseBuffer.getChannelData(0)
    for (let i = 0; i < noiseBuffer.length; i++) {
      output[i] = Math.random() * 2 - 1
    }

    const noise = ctx.createBufferSource()
    noise.buffer = noiseBuffer

    const noiseFilter = ctx.createBiquadFilter()
    noiseFilter.type = 'bandpass'
    noiseFilter.frequency.setValueAtTime(150, now)
    noiseFilter.frequency.exponentialRampToValueAtTime(3000, now + 0.25)
    noiseFilter.frequency.exponentialRampToValueAtTime(80, now + 0.6)
    noiseFilter.Q.setValueAtTime(3, now)

    const noiseGain = ctx.createGain()
    noiseGain.gain.setValueAtTime(0, now)
    noiseGain.gain.linearRampToValueAtTime(0.4, now + 0.15)
    noiseGain.gain.linearRampToValueAtTime(0, now + 0.6)

    noise.connect(noiseFilter)
    noiseFilter.connect(noiseGain)
    noiseGain.connect(ctx.destination)
    noise.start(now)

    // 2. Victory fanfare - ascending triumphant notes
    const victoryNotes = [
      { freq: 523.25, time: 0.3 }, // C5
      { freq: 659.25, time: 0.4 }, // E5
      { freq: 783.99, time: 0.5 }, // G5
      { freq: 1046.5, time: 0.6 }, // C6
    ]

    victoryNotes.forEach(({ freq, time }) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()

      osc.type = 'triangle'
      osc.frequency.setValueAtTime(freq, now + time)

      gain.gain.setValueAtTime(0, now + time)
      gain.gain.linearRampToValueAtTime(0.25, now + time + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.01, now + time + 0.4)

      osc.connect(gain)
      gain.connect(ctx.destination)

      osc.start(now + time)
      osc.stop(now + time + 0.5)
    })

    // 3. Power chord for emphasis (plays with final note)
    const powerChord = [1046.5, 1318.5] // C6 + E6

    powerChord.forEach((freq) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()

      osc.type = 'sawtooth'
      osc.frequency.setValueAtTime(freq, now + 0.6)

      gain.gain.setValueAtTime(0, now + 0.6)
      gain.gain.linearRampToValueAtTime(0.2, now + 0.65)
      gain.gain.exponentialRampToValueAtTime(0.01, now + 1.2)

      osc.connect(gain)
      gain.connect(ctx.destination)

      osc.start(now + 0.6)
      osc.stop(now + 1.2)
    })

    // 4. Sparkle/shimmer effect for celebration
    for (let i = 0; i < 3; i++) {
      const sparkle = ctx.createOscillator()
      const sparkleGain = ctx.createGain()

      sparkle.type = 'sine'
      sparkle.frequency.setValueAtTime(2000 + i * 500, now + 0.7 + i * 0.1)

      sparkleGain.gain.setValueAtTime(0.1, now + 0.7 + i * 0.1)
      sparkleGain.gain.exponentialRampToValueAtTime(0.01, now + 0.9 + i * 0.1)

      sparkle.connect(sparkleGain)
      sparkleGain.connect(ctx.destination)

      sparkle.start(now + 0.7 + i * 0.1)
      sparkle.stop(now + 0.9 + i * 0.1)
    }
  } catch (e) {
    console.error('Audio playback failed', e)
  }
}
